<template lang="pug">
div    
    form-insert(:IsShowModal.sync="IsShowModalInsert",
                :nameModulo="nameModulo",
                :InfoUser.sync="InfoUser",
                :InfoDocument.sync="InfoDocument",
                :InfoCategory.sync="InfoCategory",
                :InfoFrecuncy.sync="InfoFrecuncy",
                :InfoPeriod.sync="InfoPeriod", 
                :parameter.sync="parameterInsert", 
                @sendInfo="val => Insert(val)")
    form-update(:IsShowModal.sync="IsShowModalUpdate",
                :nameModulo="nameModulo",
                :parameter.sync="parameterUpdate",
                :InfoUser.sync="InfoUser",
                :InfoDocument.sync="InfoDocument",
                :InfoCategory.sync="InfoCategory",
                :InfoFrecuncy.sync="InfoFrecuncy",
                :InfoPeriod.sync="InfoPeriod", 
                @sendInfo="val => Update(val)")
    .card.bg-menu.text-white.form-group.col-md-4.col-sm-12(v-if="IsShowEnterprise")
        .card-body  
            label Selecion de Empresa
            select.form-control.form-control-sm(v-if="tableEnterprise", v-model="selectEnterprise",@change="setValueInit()")
                option(v-for="(item,index) in tableEnterprise", :value="item.IdEnterprise") {{item.BusinessName}} 
    v-card
        v-card-title(class="elevation-1") 
            | Mantenedor {{nameModulo}}
            v-spacer
            v-btn(color="warning" @click="IsShowModalInsert=true") Asignar Meta 
                i.fa.fa-plus-circle
        v-container( fluid)
            form-view(:parameter.sync="parameterView",:tablaInfo.sync="tableInfoGroup", @sendSearch="val => List_Info_Details(val)", @sendRefresh="val => List_Info(val)" ) 
    form-view-details(v-show="IsShowModalViewDetails" :IsShowModal.sync="IsShowModalViewDetails", :parameter.sync="parameterView",:tablaInfo.sync="tableInfoSelect", @sendInfo="val => {IsShowModalUpdate=true,parameterUpdate=val}" ) 

</template>
<script> 
import apiWeb from "../../api/apiSLC.js"
import model from "../../models/goalMaintainerSSO.js" 
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
import formViewDetails from './components/viewDetails.vue'
export default {
    components:{
                formInsert,
                formUpdate,
                formView,
                formViewDetails
    },
    data(){
        return{
                nameModulo:'Metas',
                pathApi:'GoalMaintainerSSO/GoalMaintainerSSO',
                selectEnterprise:'0',
                tableEnterprise:[],
                IsShowModalInsert:false,
                IsShowModalUpdate:false,
                IsShowModalConfig:false,
                IsShowModalViewDetails:false,

                InfoUser:[],
                InfoDocument:[],
                InfoCategory:[],
                InfoFrecuncy:[],
                InfoPeriod:[],
                ItemSelect:{},
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterView),
                tableInfo:[],
                tableInfoGroup:[],
                tableInfoSelect:[],
                IsShowEnterprise:false
        }
    }, 
    created(){ 
        if(this.$info.idEnterprise==1 && this.$info.typeAccount==4){
            this.List_Enterprise()
            this.IsShowEnterprise=true
        }
        else{
            this.IsShowEnterprise=false
            this.selectEnterprise=this.$info.idEnterprise
        }
        this.setValueInit() 
        this.Get_InfoUser()
        this.Get_Document()
        this.Get_Category()
        this.Get_Frecuency()       
        this.Get_Period()
    },
    methods:{     
        Delete_Document(item){
            console.log(item)
            this.$msgbox.confirm("¿Esta Seguro de Eliminar este Registro?","Confirmacion").then( result=> {
                if(result)
                {
                    apiWeb.post(this.pathApi + "_Delete",{idEnterprise:this.selectEnterprise, idDocType:item.IdDocType})
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.IsShowModalUpdate=false
                                this.$msgbox.show("Eliminado","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
                }
            }            
            )
        }, 
        Get_InfoUser(){
            var params={
                IdEnterprise:this.selectEnterprise,
                NameUser:'',
                Email:'',
                Active:1
            }
            apiWeb.post("Users/Users_View",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoUser=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        Get_Document(){
            var params={
                IdEnterprise:this.selectEnterprise,
                Name:'', 
                Active:1
            }
            apiWeb.post("DocumentType/DocumentType_View",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoDocument=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        Get_Category(){
            var params={
                IdEnterprise:this.selectEnterprise, 
                Active:1
            }
            apiWeb.post("DocCategory/DocCategory_ViewAll",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoCategory=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        Get_Frecuency(){
            var params={
                IdEnterprise:this.selectEnterprise, 
                Active:1
            }
            apiWeb.post("GoalMaintainerSSO/GoalMaintainerSSO_Frequency",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoFrecuncy=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },    
        Get_Period(){
            var params={
                IdEnterprise:this.selectEnterprise, 
                Active:1
            }
            apiWeb.post("GoalMaintainerSSO/GoalMaintainerSSO_Period",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoPeriod=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },   
        List_Enterprise(){
            apiWeb.post("Enterprise/Enterprise_View",{ RUT:'',BusinessName:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0){ 
                                    this.tableEnterprise=JSON.parse(result.value)
                                    if(this.selectEnterprise=='' && this.tableEnterprise.length>0)
                                        this.selectEnterprise=this.tableEnterprise[0].IdEnterprise
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        setValueInit(){            
            this.parameterView.IdEnterprise=this.selectEnterprise
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
            this.List_Info()
        },
        List_Info_Details(item){  
            this.tableInfoSelect=this.tableInfo.filter(b => b.IdDocType==item.IdDocType && b.IdUser==item.IdUser && b.Period==item.Period)           
            this.IsShowModalViewDetails=true
        },
        List_Info(){
            this.parameterView.IdEnterprise=this.selectEnterprise
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                    this.GroupInfo()
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        GroupInfo(){
        var helper = {};
        this.tableInfoGroup=[]
        let result = Object.values(this.tableInfo.reduce((a, curr)=>{
            var key = curr.IdUser + '-' + curr.IdDocType+ '-' + curr.Period;
            if(!helper[key]) {
              helper[key]= Object.assign({}, {
                                                IdUser : curr.IdUser, 
                                                NameUser : curr.NameUser, 
                                                NameDocType : curr.NameDocType,
                                                Period : curr.Period,  
                                                Quantity_Category : 1,
                                                Details:'',
                                                Period:curr.Period,
                                                IdDocType:curr.IdDocType
                                                
                                                } );
              a.push(helper[key])
            }
            else{  
              helper[key].Quantity_Category += 1; 
            }          
          return a;
        },[]));
 
        this.tableInfoGroup=result
        if(this.IsShowModalViewDetails==true){
            this.List_Info_Details(this.parameterUpdate)
        }
        
        //this.tableInfoGroupHead=[]
        // Object.keys(this.productoAGrupados[0]).forEach(element =>
        //                     { 
        //                       this.tableInfoGroupHead.push({text: _texto.capitalize(), value:element,class:'headerth'})
                               
        //                     })
      },
        async Insert(){
            var MONTH=this.parameterInsert.Month;
            if(MONTH.length>0){
                var init=parseInt(MONTH[0].substring(MONTH[0].length-2,MONTH[0].lenght))
                var end=parseInt(MONTH[1].substring(MONTH[1].length-2,MONTH[1].lenght))
                 
                for(let i=init;i<=end;i++){
                    await this.Insert_SERVER(i)
                }
              // this.Insert_SERVER( )
              this.parameterInsert=Object.assign({}, model.parameterInsert)
              this.parameterInsert.IdEnterprise=this.selectEnterprise
            }
            else{
                 this.Insert_SERVER(0)
            }
        },
        async Insert_SERVER(mes){
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterInsert.User=this.$info.email
            this.parameterInsert.IP=this.$info.ip 
            this.parameterInsert.Month=mes 
            await apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                    .then(result=>{ 
                            if(result.status==0){
                                this.List_Info()
                                this.IsShowModalInsert=false
                               // this.parameterInsert=Object.assign({}, model.parameterInsert)
                                this.parameterInsert.IdEnterprise=this.selectEnterprise
                                this.$msgbox.show("Ingresado " + mes,"Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }

                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update(){
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.User=this.$info.email
            this.parameterUpdate.IP=this.$info.ip
            apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                    .then(result=>{ 
                             if(result.status==0){ 
                                this.List_Info()                                
                                this.IsShowModalUpdate=false 
                              
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
    }
}
</script>